"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendedCast = void 0;
const sanitizers_1 = require("@restless/sanitizers");
function extendedCast(data, sanitizer, message = '') {
    const result = sanitizer(data, 'path');
    if (sanitizers_1.Result.isOk(result)) {
        return result.ok;
    }
    else {
        const extractedSanitizerErrorOutput = JSON.stringify(result);
        message = message.concat(' => ', extractedSanitizerErrorOutput);
        throw new sanitizers_1.CastError(result.error, message);
    }
}
exports.extendedCast = extendedCast;
//# sourceMappingURL=extendedCast.js.map